import React from "react";
import './styles.scss';
import DATA from 'utils/data.json';

const WHY_DATA = DATA.why;

const Why = () => {
    
    return (
        <section id='why-id' className="container">
            <div className="why-block">
                <p className="title title__1">{WHY_DATA.title[0]}</p>
                <p className="title title__2">{WHY_DATA.title[1]}</p>
                <div className="content">
                    {WHY_DATA.content.map((item, index) => {
                        return (
                            <div className="item" key={index}>
                                <img src={`/images/icon-done-ring-round.svg`} alt='' className='item__icon'/>
                                <p className="item__text" dangerouslySetInnerHTML={{__html: item}}/>
                            </div>
                        )
                    })}
                </div>
            </div>
        </section>
    )
}

export default Why